(function($){
    $(function(){
        var $mmSlider = $('.zn-mm-slider > .zn-stage');

        if ($mmSlider.length) {
            $mmSlider.each(function() {
                var $this = $(this),
                    currentSlide = 1,
                    slider = $this.sudoSlider({
                        continuous:true,
                        responsive:true,
                        auto:false,
                        speed:500,
                        numeric:true,
                        prevNext:true,
                        moveCount: 1,
                        slideCount: 3,
                        initCallback: function () {
                            slider.getSlide(currentSlide).addClass('zn-active');

                            var $controls = slider.next('.controls');
                            
                            slider.find('ul').attr('aria-live', 'polite').attr('role', 'region');

                            $controls.find('.prevBtn').attr('aria-label', 'Navigate to previous slide').attr('title', 'Previous Slide');
                            $controls.find('.nextBtn').attr('aria-label', 'Navigate to next slide').attr('title', 'Next Slide');;

                            $controls.find('ol li a').each(function(){
                                var $this = $(this),
                                    target = $this.parent('li').attr('data-target');

                                $this.attr('aria-label', 'Navigate to slide ' + target).attr('title', 'Slide ' + target);
                            });
                        },
                        beforeAnimation: function (t) {
                            slider.getSlide(currentSlide).removeClass('zn-active');
                            slider.getSlide(t).addClass('zn-active');
                        },
                        afterAnimation: function (t) {
                            currentSlide = t;     
                        }
                      }),
                    moves = [
                        {
                          min:0,
                          max:399,
                          enter: function() { 
                            slider.setOption('slideCount',1);
                          },
                          exit: function() {}
                        },
                        {
                          min:400,
                          max:1023,
                          enter: function() { 
                            slider.setOption('slideCount',2);
                          },
                          exit: function() {}
                        },
                        {
                          min:1024,
                          max:9999999,
                          enter: function() { 
                            slider.setOption('slideCount',3);
                          },
                          exit: function() {}
                        }
                    ];

                    breakdance(moves);
                
            });
        }
    });
})($JQ);